/* Froens - Vista rapida: la talla NO viene preseleccionada.
   El cliente debe elegirla; mientras no lo haga, el boton avisa y no agrega al carro.
   El estado vive en JS (no en atributos) porque el tema re-renderiza el formulario y borra atributos ajenos. */
(function () {
  var SIZE_RE = /talla|size/i;
  var TXT = 'Elige tu talla';
  var ROOT = '.quickview__modal .quickview__form';
  var picked = {}; // handle de producto -> el cliente ya eligio talla

  function sizeRadios(root) {
    var all = root.querySelectorAll('input[type=radio][name^="options["]');
    var out = [];
    for (var i = 0; i < all.length; i++) if (SIZE_RE.test(all[i].name)) out.push(all[i]);
    return out;
  }
  function handleOf(root) {
    var f = root.querySelector('form[data-product-handle]');
    return f ? f.getAttribute('data-product-handle') : '';
  }
  function isPending(root) {
    return sizeRadios(root).length > 1 && !picked[handleOf(root)];
  }

  // deja la vista rapida en estado "sin talla" (idempotente: solo escribe si hay diferencia)
  function ensure(root) {
    if (!isPending(root)) {
      if (root.hasAttribute('data-froens-size-pending')) release(root);
      return;
    }
    var radios = sizeRadios(root);
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) radios[i].checked = false;
    var fs = radios[0].closest('fieldset');
    var legend = fs && fs.querySelector('[data-option-value]');
    if (legend && legend.textContent !== '') legend.textContent = '';
    if (root.getAttribute('data-froens-size-pending') !== '1') root.setAttribute('data-froens-size-pending', '1');
    var t = root.querySelector('[data-add-to-cart-text]');
    if (t && t.textContent.trim() !== TXT) {
      t.dataset.froensOrig = t.dataset.froensOrig || t.textContent.trim();
      t.textContent = TXT;
    }
    var btn = root.querySelector('[data-add-to-cart]');
    if (btn && !btn.classList.contains('froens-qv-needsize')) btn.classList.add('froens-qv-needsize');
  }
  function release(root) {
    root.removeAttribute('data-froens-size-pending');
    root.classList.remove('froens-qv-warn');
    var t = root.querySelector('[data-add-to-cart-text]');
    if (t && t.textContent.trim() === TXT) t.textContent = (t.dataset.froensOrig || 'Agregar al carrito');
    var btn = root.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.remove('froens-qv-needsize');
  }

  function scan() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) ensure(roots[i]);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  // el cliente elige talla: se libera el boton
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.type !== 'radio' || !SIZE_RE.test(el.name || '')) return;
    var root = el.closest(ROOT);
    if (!root) return;
    picked[handleOf(root)] = true;
    release(root);
  }, true);

  // al cerrar la vista rapida se olvida la eleccion (la proxima apertura parte sin talla)
  function reset() { picked = {}; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.quickview__modal') && t.closest('[data-micromodal-close], .drawer__close')) reset();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') reset(); }, true);

  // sin talla: no se agrega, se avisa
  function guard(e) {
    var root = e.target && e.target.closest && e.target.closest(ROOT);
    if (!root || !isPending(root)) return;
    if (e.type === 'click' && !e.target.closest('[data-add-to-cart]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    root.classList.add('froens-qv-warn');
    var fs = root.querySelector('.radio__fieldset');
    if (fs && fs.scrollIntoView) fs.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  scan();
})();

/* Froens - Tarjeta de recomendacion con chips de talla (snippets/product-clip.liquid, froens_chips_on).
   El cliente elige una talla (no viene preseleccionada) y recien ahi el boton agrega esa variante al carro.
   El agregado lo hace el propio tema (productAddButtonForm lee el input hidden "id" del formulario al hacer click);
   aqui solo se cambia ese id y se bloquea el click mientras no haya talla. */
(function () {
  var TXT_ADD = 'Agregar al carro';

  function cardOf(el) { return el && el.closest ? el.closest('[data-froens-clip]') : null; }

  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('.froens-clip__size') : null;
    if (chip) {
      if (chip.disabled) return;
      var c = cardOf(chip);
      if (!c) return;
      var chips = c.querySelectorAll('.froens-clip__size');
      for (var i = 0; i < chips.length; i++) {
        var on = chips[i] === chip;
        chips[i].classList.toggle('is-on', on);
        chips[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      var input = c.querySelector('form input[name="id"]');
      if (input) input.value = chip.getAttribute('data-froens-variant');
      c.setAttribute('data-picked', '1');
      c.classList.remove('froens-clip--warn');
      var label = c.querySelector('.froens-clip__add .btn-state-ready');
      if (label) label.textContent = TXT_ADD;
    }
  }, false);

  // sin talla elegida: no se agrega, se avisa (captura: corre antes que el manejador del tema)
  function guard(e) {
    var add = e.target && e.target.closest ? e.target.closest('.froens-clip__add') : null;
    var c = add ? cardOf(add) : (e.type === 'submit' ? cardOf(e.target) : null);
    if (!c || c.getAttribute('data-picked') === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    c.classList.remove('froens-clip--warn');
    void c.offsetWidth; // reinicia la animacion
    c.classList.add('froens-clip--warn');
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
})();
